<script setup>
import {computed, ref, watch} from 'vue'
import tooltip from '@/vue/directives/tooltip'
import {useEmailEventsStore} from '@/stores/emailEvents'

const vTooltip = tooltip

const props = defineProps({
    item: Object,
    value: Object
})

const emailEventsStore = useEmailEventsStore()

const allEvents = ref(null)

const items = computed(() => {
    if (allEvents.value) {
        // We only want to present the most recent event for each recipient, otherwise it will
        // clutter the UI with lots of "Accepted" events. So by sorting by -eventDate (above)
        // we can just include the first event for each recipient.
        const result = []
        const recipients = []
        allEvents.value.forEach((o) => {
            if (recipients.indexOf(o.recipient) === -1) {
                result.push(o)
                recipients.push(o.recipient)
            }
        })

        return result
    }
    return []
})

watch(() => props.item?.id, async (newId) => {
    if (!newId) {
        allEvents.value = null
        return
    }
    allEvents.value = await emailEventsStore.get(newId)
}, {immediate: true})

const getClass = (event) => {
    const labels = {
        accepted: 'bg-warning',
        rejected: 'bg-danger',
        delivered: 'bg-success',
        failed: 'bg-danger',
        opened: 'bg-success',
        clicked: 'bg-success',
        unsubscribed: 'bg-danger',
        complained: 'bg-danger',
        stored: 'bg-warning'
    }

    if (event && Object.prototype.hasOwnProperty.call(labels, event)) {
        return labels[event]
    }
    return ''
}
</script>

<template>
    <span v-if="items.length" class="wrapper">
        <span v-for="(item, index) in items" :key="index" v-tooltip :class="getClass(item.event)"
              :title="item.recipient" class="badge me-1" data-bs-placement="bottom" data-bs-toggle="tooltip"
              style="text-transform: capitalize">
            {{ item.event }}
        </span>
    </span>
</template>

<style scoped>
.wrapper {
    display: inline-block;
    min-width: 80px;
}
</style>